module.exports = __webpack_public_path__ + "static/img/1615_phase_function_Paper_PointsHejduk_Prediction.b8411a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/1615_phase_function_Paper_PointsHejduk_Prediction.png
// module id = dQdR
// module chunks = 0